import { ReactComponent as CircleExclamation } from '../../../assets/icons/CircleExclamation.svg';
import Tooltip from '../../Tooltip/Tooltip';

import classes from './LabelField.module.scss';

const LabelField = ({ className, name, label, children, popover }) => {
  const containerClasses = [classes.container];
  if (className) {
    containerClasses.push(className);
  }

  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes['content-label']}>
        <label className='medium-14' htmlFor={name}>
          {label}
        </label>
        {popover && (
          <Tooltip key='popover' content={<b>{popover}</b>} position='top'>
            <CircleExclamation />
          </Tooltip>
        )}
      </div>
      {children}
    </div>
  );
};

export default LabelField;
